import __request__ from "routing/request";
export function list(sort = "title", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.collections/collections", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.collections/collections", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(Collectionstoremove, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.collections/collections/bulk_delete", Collectionstoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getCollectionSharing(entityGRN, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/collections/collection_sharing/${entityGRN}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkAdd(Entitiestoadd, collectionId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.collections/collections/entities/bulk_add/${collectionId}`, Entitiestoadd, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDeleteBycollectionIdAndEntitiestoremove(Entitiestoremove, collectionId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.collections/collections/entities/bulk_delete/${collectionId}`, Entitiestoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getCandidateEntitiesPage(sort = "name", collectionId, page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/collections/entities/candidates/paginated/${collectionId}`, null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEntitiesPage(sort = "name", collectionId, page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/collections/entities/paginated/${collectionId}`, null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, order = "asc", editable = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.collections/collections/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order, "editable": editable }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSharedPaginated(entityId, entity_type, sort = "title", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/collections/shares/${entityId}/paginated`, null, { "entity_type": entity_type, "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStatuses(entity_grns, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.collections/collections/status", entity_grns, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(collectionId, collection, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.collections/collections/${collectionId}`, collection, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(collectionId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/collections/${collectionId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(collectionId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.collections/collections/${collectionId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateEntities(collectionId, updaterequest, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.collections/collections/${collectionId}/entities`, updaterequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateCollections(entityGRN, request, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.collections/collections/${entityGRN}/collections`, request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
